import { ApolloError } from '@collinsonx/utils/apollo';
import Error from '@components/Error';
import useLocale from 'hooks/useLocale';

interface LoungeErrorProps {
  error: ApolloError;
  title?: string;
}

const LoungeError = ({ error, title }: LoungeErrorProps) => {
  const translations = useLocale();

  return (
    <Error
      aria-label={translations.generic.labels.notification}
      error={error}
      title={title ?? translations.generic.error.unhandledError.title}
    />
  );
};

export default LoungeError;
